import type { XingletInterface } from '../xinglet-helpers';
import { XingletWrapper } from '../xinglet-helpers';

import type { TemplateProps } from './';

export type TemplateCoverLetterTraditionalProps = TemplateProps;
export type TemplateCoverLetterTraditionalXinglet =
  XingletInterface<TemplateCoverLetterTraditionalProps>;

export const CoverLetterTraditional =
  XingletWrapper<TemplateCoverLetterTraditionalProps>(
    `@xing-com/crate-lebenslauf-templates-cover-letter-traditional`
  );
